import React from "react";

const Map = (props: any) => {
  
  let {
    suffix = 0
  } = props
  
  return (
    <div
      id={`map-container`}
      style={{height: "100%", width: "100%"}}/>
  )
}

export default Map;